'use client'
import { useInView } from 'react-intersection-observer'

// Components
import { MarkdownRenderer } from '@/components/shared/markdown-renderer'
import BlurImage from '@/components/shared/blur-image'

// Utils
import { cn, placeholderBlurhash } from '@/lib/utils'

// Config
import { siteConfig } from '@/config/site'

// Types
import type { Dictionary } from '@/types/global'

export function HomeAbout({ dictionary }: { dictionary: Dictionary }) {
  const [ref, isInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  })
  return (
    <section id={dictionary.home.about.title} className="">
      <div
        ref={ref}
        className="mx-auto grid max-w-7xl gap-8 py-12 pb-16 md:gap-12 lg:grid-cols-2 lg:gap-16 lg:py-20"
      >
        <div className="">
          {isInView && (
            <video
              className={cn(
                isInView ? 'animate-fade-in' : 'opacity-0',
                'h-auto max-h-[550px] w-full object-cover object-center hidden lg:block lg:rounded-xl'
              )}
              autoPlay
              muted
              playsInline
              src="/assets/videos/home/about-2.mp4"
            />
          )}
        </div>
        <div>
          <h2 className="text-balance px-4 py-3 font-heading text-2xl text-muted-foreground">
            {dictionary.home.about.title}
          </h2>
          <div className="max-w-[300px] px-3 pb-6">
            <BlurImage
              alt={siteConfig.title}
              blurDataURL={placeholderBlurhash}
              width={800}
              height={193}
              placeholder="blur"
              className="size-full invert"
              src="/assets/images/logo-wordmark.png"
            />
          </div>

          <MarkdownRenderer content={dictionary.home.about.description} />
        </div>
      </div>
    </section>
  )
}
